module.exports = __webpack_public_path__ + "img/lk.lk3cb867c.svg";